export default __webpack_public_path__ + "locales/ar-SA/JavascriptSdk.json?hash=29020eb939436fcfda94f1e7cdabe16a";